export enum FileType {
  PDF = "pdf",
  VIDEO = "video",
  GDRIVE_FOLDER = "gdrive_folder",
  File = "file",
  EXTERNAL = "external",
  SOLAR_STUDY = "solar_study",
}

// Module Enum
export enum PurlModule {
  OVERVIEW = "overview",
  ADDITIONAL_RESOURCES = "additional_resources",
  TEST_MODULE = "test_module" // Todo Remove the test Module
}
